import { useEffect } from 'react'

import { useWorkspaceHistory } from '#components/FolderExplorer/hooks'
import { useMst } from '#hooks/index'

export const useDashboardData = () => {
  const root = useMst()
  const org = root.currentOrg!

  const workspaceHistoryQuery = useWorkspaceHistory(org)

  useEffect(() => {
    root.refreshFavoriteItems()
  }, [root, org.id])

  useEffect(() => {
    org.refreshMyHistory()
  }, [org, org.id])

  return {
    isLoading: workspaceHistoryQuery.isLoading,
  }
}
